import { useEffect } from "react";

const BookPHXHyattRegencyDWT = () => {
  // keep the noindex so search engines don't index this kiosk page
  useEffect(() => {
    const metaNoIndex = document.createElement("meta");
    metaNoIndex.name = "robots";
    metaNoIndex.content = "noindex, nofollow";
    document.head.appendChild(metaNoIndex);
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black">
      <iframe
        src="https://quietcove.wiseingress.com/#/quietcove;uid=175D7209-4831-45B1-9372-56D1C4253D22;source=iframe"
        className="w-full h-full border-0"
        allow="payment *; clipboard-read; clipboard-write"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        title="Quiet Corner Booking Kiosk"
      />
    </div>
  );
};

export default BookPHXHyattRegencyDWT;
